export const DEFAULT_MAX_RETAINED_TERMINAL_TURNS = 64

type TerminalRetentionEntry = {
  listeners: ReadonlySet<unknown>
  recovery: Promise<unknown> | null
  recoveryTimer: unknown | null
  state: { terminal: boolean }
  subscriptionActive: boolean
}

export function terminalEntriesToDispose<Key, Entry extends TerminalRetentionEntry>(
  entries: ReadonlyMap<Key, Entry>,
  maxRetainedTerminalTurns: number
): Array<[Key, Entry]> {
  const candidates = [...entries.entries()].filter(
    ([, entry]) =>
      entry.state.terminal &&
      entry.listeners.size === 0 &&
      !entry.subscriptionActive &&
      entry.recovery === null &&
      entry.recoveryTimer === null
  )
  return candidates.slice(0, Math.max(0, candidates.length - maxRetainedTerminalTurns))
}
